import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { CONTACT_CONFIG } from '../../config';
import { FAB_BOTTOM_SUPPORT, fabPortalFixedStyle } from '../../constants/fabDock';

/**
 * Portal body + vị trí trong cột FAB (cao nhất). Không chiếm layout trong #root → luôn cố định viewport.
 */
const ContactButtons: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    const ui = (
        <div
            className="group flex flex-col items-end relative isolate"
            style={fabPortalFixedStyle(FAB_BOTTOM_SUPPORT)}
        >
            {isOpen && (
                <div className="absolute bottom-full right-0 mb-3 flex flex-col items-end gap-3">
                    {CONTACT_CONFIG.MESSENGER_LINK && (
                        <a
                            href={CONTACT_CONFIG.MESSENGER_LINK}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-3 pr-2 pl-4 py-2 bg-blue-600 text-white rounded-2xl shadow-lg hover:bg-blue-700 transition-all hover:scale-105"
                        >
                            <span className="text-[10px] font-black uppercase tracking-widest">Messenger</span>
                            <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center">
                                <i className="ti ti-brand-messenger text-xl"></i>
                            </div>
                        </a>
                    )}

                    {CONTACT_CONFIG.HOTLINE && (
                        <a
                            href={`tel:${String(CONTACT_CONFIG.HOTLINE).replace(/\s/g, '')}`}
                            className="flex items-center gap-3 pr-2 pl-4 py-2 bg-amber-500 text-white rounded-2xl shadow-lg hover:bg-amber-600 transition-all hover:scale-105"
                        >
                            <span className="text-[10px] font-black uppercase tracking-widest">Hotline</span>
                            <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center">
                                <i className="ti ti-phone-call text-xl"></i>
                            </div>
                        </a>
                    )}

                    {CONTACT_CONFIG.ZALO_LINK && (
                        <a
                            href={CONTACT_CONFIG.ZALO_LINK}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-3 pr-2 pl-4 py-2 bg-teal-500 text-white rounded-2xl shadow-lg hover:bg-teal-600 transition-all hover:scale-105"
                        >
                            <span className="text-[10px] font-black uppercase tracking-widest">Zalo Chat</span>
                            <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center">
                                <i className="ti ti-brand-hipchat text-xl"></i>
                            </div>
                        </a>
                    )}
                </div>
            )}

            <button
                type="button"
                onClick={() => setIsOpen(!isOpen)}
                className={`w-14 h-14 rounded-2xl shadow-2xl flex items-center justify-center transition-all duration-500 shrink-0 ${isOpen ? 'bg-slate-900 rotate-180' : 'bg-teal-600 hover:scale-110 active:scale-95 animate-bounce'}`}
                aria-expanded={isOpen}
                aria-label={isOpen ? 'Đóng menu hỗ trợ' : 'Mở menu hỗ trợ'}
            >
                {isOpen ? (
                    <i className="ti ti-x text-white text-2xl"></i>
                ) : (
                    <div className="relative">
                        <i className="ti ti-headset text-white text-2xl"></i>
                        <span className="absolute -top-1 -right-1 w-3 h-3 bg-rose-500 border-2 border-teal-600 rounded-full"></span>
                    </div>
                )}
            </button>

            {!isOpen && (
                <div className="absolute right-full mr-2 top-1/2 -translate-y-1/2 bg-slate-900 text-white text-[10px] font-black uppercase tracking-widest px-3 py-1.5 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap pointer-events-none">
                    Cần hỗ trợ?
                </div>
            )}
        </div>
    );

    if (!mounted || typeof document === 'undefined') return null;
    return createPortal(ui, document.body);
};

export default ContactButtons;
